import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { ProofBuilder } from '../../models/builders/proof.builder';
import { Proof } from '../../models/proof';

const proofBody = (proof: Proof) => (
  {
    hash: proof.hash,
    name: proof.name,
    description: proof.description,
    isActive: proof.isActive
  }
);

@Injectable()
export class ProofApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}proofs`;
  }

  getProofs() {
    return this.httpClient.get(`${this.apiUrl}`)
      .pipe(
        map(ProofBuilder.fromList)
      );
  }

  getProof(hash: string) {
    return this.httpClient.get(`${this.apiUrl}/${hash}`)
      .pipe(
        map(ProofBuilder.fromJson)
      );
  }

  createProof(proof) {
    return this.httpClient.post(this.apiUrl, proofBody(proof)).pipe(map(ProofBuilder.fromJson));
  }

  updateProof(proof: Proof) {
    const body = proofBody(proof);
    return this.httpClient.put(`${this.apiUrl}/${proof.hash}`, body);
  }

  deleteProof(proof: Proof) {
    return this.httpClient.delete(`${this.apiUrl}/${proof.hash}`);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/proof-api.service.ts